// @ vendors
const get = require('lodash/object/get');
const includes = require('lodash/collection/includes');

// @ constants
const {
    CREDIT_CARD_ID_RESPONSE_APPROVED,
    CREDIT_CARD_ID_RESPONSE_PENDING,
    CREDIT_CARD_ID_RESPONSE_REJECTED,
    UNEXPECTED_ERRORS,
    LOW_CREDIT_SCORE_DESCRIPTION
} = require('constants/index');
const {
    CREDIT_CARD_CREDIT_LIMIT_EXCEEDS_MAX_CODE,
    CREDIT_CARD_MAX_CARDS_EXCEEDED_CODE,
    CREDIT_CARD_REQUEST_IN_PROGRESS_CODE,
    CREDIT_CARD_REQUEST_IN_PROGRESS_CODE_CC,
    CREDIT_CARD_WRONG_CREDIT_LIMIT_CODE,
    CREDIT_CARD_WRONG_EMAIL_FORMAT_CODE,
    CREDIT_CARD_LOW_CREDIT_SCORE,
    DEBIT_CARD_MAX_CARDS_EXCEEDED_CODE,
    DEBIT_CARD_MAX_CARDS_EXCEEDED_CODE_CC,
    CREDIT_CARD_NEXT_DAY_ERROR,
    DEBIT_CARD_SOLIDARITY_NO_FINISH_RECORD
} = require('constants/contractsErrorCodes');
const {
    KNOWN_ERROR_CODE,
    PENDING,
    REJECTED,
    LOW_CREDIT_SCORE
} = require('constants/hireCardSubmitScenarios');
const {
    LAST_ADDED_SHIPPING_ADDRESS_CODE
} = require('constants/shippingAddress');

function getCreditCardHiringStatus(response){
    let error;
    let errorMsg = '';
    let hiringStatus = '';

    // This are credit status evalutions
    if (response.estado && get(response, 'result.msg', '') === 'OK') {
        const statusId = parseInt(response.estado.id);

        if (CREDIT_CARD_ID_RESPONSE_APPROVED.includes(statusId)) {
            error = false;
        } else if (CREDIT_CARD_ID_RESPONSE_PENDING.includes(statusId) ) {
            error = false;
            hiringStatus = PENDING;
        } else if (CREDIT_CARD_ID_RESPONSE_REJECTED.includes(statusId)) {
            error = true;
            // Check for low credit score error
            var { descripcion, asnef } = response.estado;
            if (asnef != null) {
                hiringStatus = asnef === true ? LOW_CREDIT_SCORE : REJECTED;
            }else {
                hiringStatus =  (!!descripcion && descripcion === LOW_CREDIT_SCORE_DESCRIPTION) ? LOW_CREDIT_SCORE : REJECTED;
            }
        }

    } else if (!!response.msg && UNEXPECTED_ERRORS.includes(response.msg)) {
        error = true;
    } else {
        const errorCode = get(response, 'result.detalleErrorList[0].error.codigo')
            || get(response, 'result.detalleErrorList.detalleErrorList[0].error.codigo')
            || get(response, 'body.error') || get(response, 'error') || '';

        if (CREDIT_CARD_NEXT_DAY_ERROR.includes(errorCode)){
            error = false;
        } else {
            const creditErrors = {
                [CREDIT_CARD_CREDIT_LIMIT_EXCEEDS_MAX_CODE]: 'currentLimitExceedsMax',
                [CREDIT_CARD_MAX_CARDS_EXCEEDED_CODE]: 'maxAllowedNumberOfCardsExceeded',
                [CREDIT_CARD_REQUEST_IN_PROGRESS_CODE]: 'requestInProgress',
                [CREDIT_CARD_REQUEST_IN_PROGRESS_CODE_CC]: 'requestInProgress',
                [CREDIT_CARD_WRONG_CREDIT_LIMIT_CODE]: 'wrongCreditLimit',
                [CREDIT_CARD_WRONG_EMAIL_FORMAT_CODE]: 'wrongEmailFormat',
                [CREDIT_CARD_LOW_CREDIT_SCORE]: 'lowCreditScore'
            };
            // If in the future more errors need handling, add cases here
            switch (errorCode) {
                case CREDIT_CARD_CREDIT_LIMIT_EXCEEDS_MAX_CODE:
                case CREDIT_CARD_MAX_CARDS_EXCEEDED_CODE:
                case CREDIT_CARD_REQUEST_IN_PROGRESS_CODE:
                case CREDIT_CARD_WRONG_CREDIT_LIMIT_CODE:
                case CREDIT_CARD_WRONG_EMAIL_FORMAT_CODE:
                case CREDIT_CARD_REQUEST_IN_PROGRESS_CODE_CC:
                    error = true;
                    hiringStatus = KNOWN_ERROR_CODE;
                    errorMsg = creditErrors[errorCode];
                    break;
                case CREDIT_CARD_LOW_CREDIT_SCORE:
                    error = true;
                    hiringStatus = LOW_CREDIT_SCORE;
                    errorMsg = creditErrors[errorCode];
                    break;
                default:
                    error= true;
                    hiringStatus = errorCode;
                    break;
            }
        }
    }

    return {
        error,
        errorMsg,
        hiringStatus
    };
}

function getDebitCardHiringStatus(response){
    let error;
    let errorMsg;
    const debitErrorCode = get(response, 'result.detalleErrorList[0].error.codigo')
        || get(response, 'result.detalleErrorList.detalleErrorList[0].error.codigo')
        || get(response, 'body.error') || get(response, 'error') || '';

    if (CREDIT_CARD_NEXT_DAY_ERROR.includes(debitErrorCode)){
        error = false;
    } else {
        const debitErrors = {
            [DEBIT_CARD_MAX_CARDS_EXCEEDED_CODE]: 'maxAllowedNumberOfCardsExceeded',
            [DEBIT_CARD_MAX_CARDS_EXCEEDED_CODE_CC]: 'maxAllowedNumberOfCardsExceeded',
            [DEBIT_CARD_SOLIDARITY_NO_FINISH_RECORD]: 'solidarityUnfinishedRecord'
        };
        const resultMsg = get(response, 'result.msg');

        if (includes(Object.keys(debitErrors), debitErrorCode)) {
            error = true;
            errorMsg = debitErrors[debitErrorCode];
        } else if (!!resultMsg && UNEXPECTED_ERRORS.includes(resultMsg)) {
            error = true;
        } else if (get(response, 'result.id') === '-1') {
            error = true;
        } else {
            error = false;
        }
    }

    return {
        error,
        errorMsg
    };
}

const domicilioExt = (immAddress) => {
    return {
        codFormatoDomicilio: 'EXT',
        domicilioExt: {
            linea1Direccion: `${immAddress.getIn(['roadName', 'value']) || '' }`,
            linea2Direccion: `${immAddress.getIn(['number', 'value']) || ''} ${immAddress.getIn(['postalCode', 'value'], '')}`,
            pais: immAddress.getIn(['country', 'value']) || '',
            plaza: immAddress.getIn(['population', 'value']) || '',
        },
        tipoDomicilio: LAST_ADDED_SHIPPING_ADDRESS_CODE
    }
}

const domicilioEsp = (immAddress) => {
    return {
        codFormatoDomicilio: 'ESP',
        domicilioEsp: {
            codigoPostal: immAddress.getIn(['postalCode', 'value']) || '',
            nombreVia: immAddress.getIn(['roadName', 'value']) || '',
            numeroVia: immAddress.getIn(['number', 'value']) || '',
            pais: immAddress.getIn(['country', 'value']) || '',
            localidad: immAddress.getIn(['population', 'value']) || '',
            anexoVia: immAddress.getIn(['others', 'value']) || '',
            plaza: {
                discriminante: 0,
                plaza: 0,
                provincia: immAddress.getIn(['province', 'value']) || ''
            },
            tipoVia: immAddress.getIn(['roadType', 'value']) || ''
        },
        tipoDomicilio: LAST_ADDED_SHIPPING_ADDRESS_CODE
    }
}

function getShippingAddressDetails(immAddress) {
    if (immAddress && immAddress.get('codFormatoDomicilio') === 'EXT'){
        return domicilioExt(immAddress);
    } else {
        return domicilioEsp(immAddress);
    }

}

function canHireCard(flagBasedFeatures, featureTogglingKey, featureTogglingFn = () => { return true }) {
    return ( !featureTogglingKey || flagBasedFeatures.get(featureTogglingKey) ) &&
        ( featureTogglingFn(flagBasedFeatures) );
}

//Expected string for getCardType, getCardSubtype, and getCardStandard is B.500.801.001
const getCardType = cardString => cardString.substring(2, 5);

const getCardSubtype = cardString => cardString.substring(6, 8);

const getCardStandard = cardString => `0000${cardString.substring(10)}`;

module.exports = {
    getCardStandard,
    getCardSubtype,
    getCardType,
    getCreditCardHiringStatus,
    getDebitCardHiringStatus,
    getShippingAddressDetails,
    canHireCard
};
